import MainContainer from "../../layout/MainContainer";
import { Card } from "@mui/material";

const PermissionDenied = () => {
  return (
    <MainContainer>
      <div className="main_title">
        <h1>Insufficient Permissions</h1>
      </div>
      <Card className="cards_permssion">
        {/* <Box className="cards_header">
          <Button className="btn btn_primary" onClick={() => navigate(-1)}>
            Back
          </Button>
        </Box> */}
        <div className="no_permissions">
          <figure>
            <img src="/static/images/lock.png" alt="" />
          </figure>

          <p>
            You do not have necessary permissions required to access this view.
            For access please contact admin.
          </p>
        </div>
      </Card>
    </MainContainer>
  );
};

export default PermissionDenied;
